import React from 'react';

const PrintAbout = ({ data }) => {
  return (
    <div className="hidden print:block mb-10">
      <div className="bg-stone-50 p-6 rounded-lg border-l-4 border-amber-600">
        <h3 className="text-3xl font-bold text-stone-900 mb-5 flex items-center">
          <span className="w-2 h-8 bg-amber-600 mr-3 rounded"></span>
          {data.title}
        </h3>
        <div className="space-y-4 text-stone-700 text-base leading-relaxed">
          <p className="text-justify">{data.summary}</p>
          <p className="text-justify">{data.paragraph2}</p>
          <p className="text-justify">{data.paragraph3}</p>
        </div>
      </div>
      
      {data.competencies.strategic.length > 0 && (
        <div className="mt-8 bg-gradient-to-br from-amber-50 to-stone-50 p-6 rounded-lg border border-stone-200">
          <h4 className="text-2xl font-bold text-stone-900 mb-5 flex items-center">
            <span className="w-2 h-6 bg-amber-600 mr-3 rounded"></span>
            Core Expertise
          </h4>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-base">
            {data.competencies.strategic.map((item, index) => (
              <li key={index} className="text-stone-700 flex items-start">
                <span className="text-amber-600 mr-3 text-xl font-bold">●</span>
                <span className="pt-0.5">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PrintAbout;